import { UserInfo } from '@faro/user-management-model';
import { Permissions } from './Permissions';

export interface AppPermissions {
    study: Permissions;
    textSnippet: Permissions;
    user: Permissions;
    studyStatus: Permissions;
    exportInsights: Permissions;
    edc: Permissions;
    studyDefinitionExport: Permissions;
    documentTemplate: Permissions;
}

const permissionsByRole = new Map<string, string[]>([
    ['EDITOR', ['study:read', 'study:write', 'export-insights:read']],
    ['VIEWER', ['study:read', 'export-insights:read']],
    ['DYNAMIC-FIELD-DEF-ADMIN', ['dynamic-field-definition:write']],
    ['SNIPPET-ADMIN', ['snippet:write']],
    ['USER-ADMIN', ['user:write']],
    ['STUDY-DEFINITION-ADMIN', ['study-status:write', 'export-insights:read', 'study-definition-export:write']],
    ['EDC-ADMIN', ['import-forms:write', 'mapping:write', 'export:write']],
    ['DOCUMENT-TEMPLATE-ADMIN', ['document-template:write']],
]);

export function getAppPermissions(user: UserInfo): AppPermissions {
    const permissions = (user.roles || []).reduce((permissions: Set<string>, role: string) => {
        const rolePermissions = permissionsByRole.get(role);
        rolePermissions?.forEach(permission => {
            permissions.add(permission);
        });
        return permissions;
    }, new Set<string>());

    return {
        study: {
            write: permissions.has('study:write'),
            read: permissions.has('study:read'),
        },
        textSnippet: {
            write: permissions.has('snippet:write'),
            read: permissions.has('snippet:read') || permissions.has('snippet:write'),
        },
        user: {
            write: permissions.has('user:write'),
            read: permissions.has('user:read') || permissions.has('user:write'),
        },
        studyStatus: {
            write: permissions.has('study-status:write'),
            read: permissions.has('study-status:read') || permissions.has('study-status:write'),
        },
        exportInsights: {
            write: permissions.has('export-insights:read'),
            read: permissions.has('export-insights:read'),
        },
        edc: {
            write:
                permissions.has('import-forms:write') ||
                permissions.has('mapping:write') ||
                permissions.has('export:write'),
            read:
                permissions.has('import-forms:write') ||
                permissions.has('mapping:write') ||
                permissions.has('export:write'),
        },
        studyDefinitionExport: {
            write: permissions.has('study-definition-export:write'),
            read: permissions.has('study-definition-export:read'),
        },
        documentTemplate: {
            write: permissions.has('document-template:write'),
            read: permissions.has('document-template:read') || permissions.has('document-template:write'),
        },
    };
}
